"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnboardingRoute = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const licenses_1 = require("@completeanatomy/licenses");
const router_1 = require("../router");
// eslint-disable-next-line max-lines-per-function
const getOnboardingRoute = ({ currentRegion, privacyPolicyAccepted, pushNotificationsDeclined, pushNotificationsEligible, cachedUserSurvey, showProfileSurvey, showRedeemCodePopover, showSurveyCompleted, showSubscriptionSheet, callRestorePurchase, callOnBuy, user, userLicenses, storage, }) => {
    const isPrivacyPolicyAccepted = privacyPolicyAccepted === 'true';
    const isPushNotificationsCompleted = pushNotificationsDeclined === 'true' ||
        pushNotificationsDeclined === 'false';
    const shouldShowPushNotifications = pushNotificationsEligible && !isPushNotificationsCompleted;
    const shouldShowRedeemCodePopover = showRedeemCodePopover === 'true';
    const shouldShowSurveyCompleted = showSurveyCompleted === 'true';
    const shouldCallRestorePurchase = callRestorePurchase === 'true';
    const shouldCallOnBuy = callOnBuy === 'true';
    const hasSubsheetCall = shouldCallOnBuy || shouldCallRestorePurchase;
    const hasCurrentSubscription = userLicenses && (userLicenses === null || userLicenses === void 0 ? void 0 : userLicenses.length) > 0 && !(0, licenses_1.isTrialLicenses)(userLicenses);
    const shouldShowSubscriptionSheet = showSubscriptionSheet === 'true' &&
        (!hasCurrentSubscription || hasSubsheetCall);
    const hasIdentifier = user === null || user === void 0 ? void 0 : user.identifier;
    const hasKind = (user === null || user === void 0 ? void 0 : user.kind) && (user === null || user === void 0 ? void 0 : user.kind) !== '-';
    /** PRIVACY POLICY ===
     * New launch users:
     *  - If Chinese region => [PRIVACY POLICY].
     *  - If ROW region => Auto-accept privacy policy. Continue onboarding.
     *
     * Existing users:
     *  - If haven't already: Auto-accept privacy policy. Continue onboarding.
     */
    if (!isPrivacyPolicyAccepted) {
        if (currentRegion === bridge_schema_1.AppRegion.China) {
            storage === null || storage === void 0 ? void 0 : storage.put('pushNotificationsDeclined', 'true');
            return `${router_1.Route.Base}/${router_1.Route.SelectRegion}/${router_1.Route.PrivacyPolicy}`;
        }
        else {
            storage === null || storage === void 0 ? void 0 : storage.put('isPrivacyPolicyAccepted', 'true');
        }
    }
    /** PUSH NOTIFICATIONS ===
     * For all users: Check if PN have been asked previously.
     *  - If PN is not completed && PN-eligible => [PUSH NOTIFICATIONS].
     *  - If PN-ineligible or completed => Continue onboarding.
     */
    if (!isPushNotificationsCompleted) {
        if (shouldShowPushNotifications) {
            return `${router_1.Route.Base}/${router_1.Route.PushNotifications}`;
        }
        else {
            storage === null || storage === void 0 ? void 0 : storage.put('pushNotificationsDeclined', 'true');
        }
    }
    /** REDEEM CODE POPOVER ===
     *  If user paused at [REDEEM CODE POPEVER].
     */
    if (shouldShowRedeemCodePopover) {
        if (user === null || user === void 0 ? void 0 : user.identifier) {
            return `${router_1.Route.Base}/${router_1.Route.RedeemCode}`;
        }
        else {
            return `${router_1.Route.Base}/${router_1.Route.ProfileSurvey}/${router_1.Route.ProfileComplete}`;
        }
    }
    /** PROFILE SURVEY COMPLETE ===
     *  If user paused at [PROFILE SURVEY/COMPLETE PAGE].
     */
    if (shouldShowSurveyCompleted) {
        return `${router_1.Route.Base}/${router_1.Route.ProfileSurvey}/${router_1.Route.ProfileComplete}`;
    }
    /** SUBSCRIPTIONS SHEET ===
     *  If new user paused at [SUBSCRIPTION SHEETS].
     */
    if (shouldShowSubscriptionSheet) {
        return `${router_1.Route.Base}/${router_1.Route.SubscriptionsSheet}`;
    }
    /** MISSING PROFILE ===
     * Existing user did not complete profile survey.
     */
    if (hasIdentifier && !hasKind) {
        if (cachedUserSurvey) {
            return `/hub`;
        }
        return `${router_1.Route.Base}/${router_1.Route.ProfileSurvey}/${router_1.Route.MissingProfile}`;
    }
    else if (
    /** HUB ===
     * Case 1: Existing user is logged in and has completed profile survey.
     * Case 2: Existing user had logged out and did not log back in.
     *  - showProfileSurvey flag is false.
     * BUG?: Case 3: Logged out -> Just registered new user.
     */
    (showProfileSurvey === 'false' && !shouldShowSurveyCompleted) ||
        (hasIdentifier && hasKind)) {
        if (hasIdentifier && hasKind) {
            //For users who sign in during Welcome Page.
            storage === null || storage === void 0 ? void 0 : storage.put('shouldShowUserSurvey', 'false');
        }
        return `/hub`;
    }
    else {
        /** USER PROFILE SURVEY ===
         * Case: New user is experiencing profile survey for the first time.
         *  - Does not have 'showProfileSurvey' flag yet.
         */
        // storage?.put('shouldShowUserSurvey', 'true');
        return `${router_1.Route.Base}/${router_1.Route.ProfileSurvey}`;
    }
};
exports.getOnboardingRoute = getOnboardingRoute;
